import {ApiService} from "../index";
import {APIConfig} from "../../../constants";

const getLabListLite = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.LAB_LIST_LITE.METHOD](APIConfig.LAB_LIST_LITE.URL, payload);
}

const getLabDetails = (labId:any,payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_LAB_DETAILS.METHOD](APIConfig.GET_LAB_DETAILS.URL(labId), payload);
}

const addLabDetails = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ADD_LAB_Details.METHOD](APIConfig.ADD_LAB_Details.URL, payload);
}

const editDirectorDetails = (labId:any,payload:any)=>{
    // @ts-ignore
    return ApiService[APIConfig.EDIT_DIRECTOR_DETAILS.METHOD](APIConfig.EDIT_DIRECTOR_DETAILS.URL(labId), payload);
}
const addDirectorAttachments=(labId:string|number,payload:any)=>{
    // @ts-ignore
    return ApiService[APIConfig.ADD_DIRECTOR_ATTACHMENTS.METHOD](APIConfig.ADD_DIRECTOR_ATTACHMENTS.URL(labId), payload);
}

const addNewSendOutSession = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ADD_NEW_SEND_OUT_SESSION.METHOD](APIConfig.ADD_NEW_SEND_OUT_SESSION.URL, payload);
}

const downloadSendOutCSV = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.SEND_OUTS_CSV_DOWNLOAD.METHOD](APIConfig.SEND_OUTS_CSV_DOWNLOAD.URL, payload);
}
const downloadSendOutBatchCSV = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.SEND_OUTS_BATCH_CSV_DOWNLOAD.METHOD](APIConfig.SEND_OUTS_BATCH_CSV_DOWNLOAD.URL, payload);
}

const getSendOutSessionDetails = (sendOutSessionId: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_SEND_OUTS_SESSION_DETAILS.METHOD](APIConfig.GET_SEND_OUTS_SESSION_DETAILS.URL(sendOutSessionId));
}
const uploadSamplePdf = (sampleId: any, orderId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.UPLOAD_RESULT_PDF.METHOD](APIConfig.UPLOAD_RESULT_PDF.URL(sampleId,orderId), payload);
}

const toggleLabActiveStatus = (labId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.TOGGLE_LAB_ACTIVE_STATUS.METHOD](APIConfig.TOGGLE_LAB_ACTIVE_STATUS.URL(labId), payload);
}
const verifyLabName = (payload: any)=>{
    // @ts-ignore
    return ApiService[APIConfig.VERIFY_LAB_NAME.METHOD](APIConfig.VERIFY_LAB_NAME.URL, payload);
}

const addLabAttachment = (labId:any,payload:any)=>{
    // @ts-ignore
    return ApiService[APIConfig.ADD_LAB_ATTACHMENT.METHOD](APIConfig.ADD_LAB_ATTACHMENT.URL(labId), payload);
}
const deleteLabAttachment = (labId:any,attachmentId:any,payload:any)=>{
    // @ts-ignore
    return ApiService[APIConfig.DELETE_LAB_ATTACHMENT.METHOD](APIConfig.DELETE_LAB_ATTACHMENT.URL(labId,attachmentId), payload);
}

const getLabAttachments = (labId:any,payload:any)=>{
    // @ts-ignore
    return ApiService[APIConfig.GET_LAB_ATTACHMENTS.METHOD](APIConfig.GET_LAB_ATTACHMENTS.URL(labId), payload);
}

const addLabContactDetails = (labId:any,payload:any)=>{
    // @ts-ignore
    return ApiService[APIConfig.ADD_LAB_CONTACT_Details.METHOD](APIConfig.ADD_LAB_CONTACT_Details.URL(labId), payload);
}

const editLabDetails = (labId:any,payload:any)=>{
    // @ts-ignore
    return ApiService[APIConfig.ADD_LAB_CONTACT_Details.METHOD](APIConfig.ADD_LAB_CONTACT_Details.URL(labId), payload);
}

const editLabContactDetails = (labId:any,payload:any)=>{
    // @ts-ignore
    return ApiService[APIConfig.ADD_LAB_CONTACT_Details.METHOD](APIConfig.ADD_LAB_CONTACT_Details.URL(labId), payload);
}

const addLabDirectorDetails = (labId:any,payload:any)=>{
    // @ts-ignore
    return ApiService[APIConfig.ADD_LAB_DIRECTOR_Details.METHOD](APIConfig.ADD_LAB_DIRECTOR_Details.URL(labId), payload);
}

const sendAdminVerificationEmail = (payload:any)=>{
    // @ts-ignore
    return ApiService[APIConfig.SEND_LAB_ADMIN_VERIFICATION_EMAIL.METHOD](APIConfig.SEND_LAB_ADMIN_VERIFICATION_EMAIL.URL, payload);
}
const validateAdminDetails = (labId:any,payload:any)=>{
    // @ts-ignore
    return ApiService[APIConfig.VERIFY_LAB_ADMIN.METHOD](APIConfig.VERIFY_LAB_ADMIN.URL(labId), payload);
}
const editLabAdminDetails = (labId:any,payload:any)=>{
    // @ts-ignore
    return ApiService[APIConfig.EDIT_LAB_ADMIN_DETAILS.METHOD](APIConfig.EDIT_LAB_ADMIN_DETAILS.URL(labId), payload);
}
const addAdminDetails = (labId:any,payload:any)=>{
    // @ts-ignore
    return ApiService[APIConfig.ADD_LAB_ADMIN_DETAILS.METHOD](APIConfig.ADD_LAB_ADMIN_DETAILS.URL(labId), payload);
}
const getLabUserDetails=()=>{
    // @ts-ignore
    return ApiService[APIConfig.GET_LAB_USER_DETAILS.METHOD](APIConfig.GET_LAB_USER_DETAILS.URL);
}
const updateLabUserLocation=(labId:string|number,userId:string|number,payload:any)=>{
    // @ts-ignore
    return ApiService[APIConfig.UPDATE_LAB_USER_LOCATION.METHOD](APIConfig.UPDATE_LAB_USER_LOCATION.URL(labId,userId),payload);
}
const addLabUserDetails=(payload:any)=>{
    // @ts-ignore
    return ApiService[APIConfig.ADD_LAB_USER_DETAILS.METHOD](APIConfig.ADD_LAB_USER_DETAILS.URL, payload);

}
const removeAssignedLabUser=(payload:any)=>{
    // @ts-ignore
    return ApiService[APIConfig.REMOVE_LAB_ASSIGNED_USER.METHOD](APIConfig.REMOVE_LAB_ASSIGNED_USER.URL, payload);
}
const addLabReportSetup = (labId:any,payload:any)=>{
    // @ts-ignore
    return ApiService[APIConfig.ADD_LAB_REPORT_SETUP.METHOD](APIConfig.ADD_LAB_REPORT_SETUP.URL(labId), payload);
}
const downloadBillingReport = (payload:any)=>{
    // @ts-ignore
    return ApiService[APIConfig.DOWNLOAD_BILLING_REPORT.METHOD](APIConfig.DOWNLOAD_BILLING_REPORT.URL, payload);
}
const addLabTestAndPanels = (labId:any,payload:any)=>{
    // @ts-ignore
    return ApiService[APIConfig.ADD_LAB_TEST_AND_PANELS.METHOD](APIConfig.ADD_LAB_TEST_AND_PANELS.URL(labId), payload);
}

const getLabTestAndPanels = (labId:any,payload:any)=>{
    // @ts-ignore
    return ApiService[APIConfig.GET_LAB_TEST_AND_PANELS.METHOD](APIConfig.GET_LAB_TEST_AND_PANELS.URL(labId), payload);
}

const toggleLabTest = (labId:any,payload:any)=>{
    // @ts-ignore
    return ApiService[APIConfig.TOGGLE_LAB_TEST.METHOD](APIConfig.TOGGLE_LAB_TEST.URL(labId), payload);
}

const toggleLabPanel = (labId:any,payload:any)=>{
    // @ts-ignore
    return ApiService[APIConfig.TOGGLE_LAB_PANEL.METHOD](APIConfig.TOGGLE_LAB_PANEL.URL(labId), payload);
}

const getLabAdminsList = (payload:any)=>{
    // @ts-ignore
    return ApiService[APIConfig.GET_LAB_ADMINS_LIST.METHOD](APIConfig.GET_LAB_ADMINS_LIST.URL, payload);
}
const updateLabRoleStatus=(payload:any)=>{
    // @ts-ignore
    return ApiService[APIConfig.UPDATE_LAB_ROLE_STATUS.METHOD](APIConfig.UPDATE_LAB_ROLE_STATUS.URL, payload);
}
const LabService = {
    getLabListLite,
    getLabDetails,
    addNewSendOutSession,
    getSendOutSessionDetails,
    uploadSamplePdf,
    toggleLabActiveStatus,
    verifyLabName,
    addLabDetails,
    editDirectorDetails,
    addDirectorAttachments,
    addLabAttachment,
    getLabAttachments,
    addLabContactDetails,
    addLabDirectorDetails,
    editLabContactDetails,
    deleteLabAttachment,
    editLabDetails,
    downloadSendOutCSV,
    downloadSendOutBatchCSV,
    sendAdminVerificationEmail,
    validateAdminDetails,
    editLabAdminDetails,
    addAdminDetails,
    getLabUserDetails,
    updateLabUserLocation,
    addLabUserDetails,
    removeAssignedLabUser,
    addLabReportSetup,
    downloadBillingReport,
    addLabTestAndPanels,
    getLabTestAndPanels,
    toggleLabTest,
    toggleLabPanel,
    getLabAdminsList,
    updateLabRoleStatus,
}

export default LabService;
